
import appMode from "./appMode";

//-- 1 - localhost, 2 - development, 3 - production
let baseDomainURL = appMode === "1" ? "http://localhost:3000/" :
appMode === "2" ? "https://eparampara.com:3060/" : 
appMode === "3" && "https://kalakriya.com/"

export default baseDomainURL